import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import MyDossierFiles from './MyDossierFiles';
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class MyDossierForm extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            title: '',
            dossierTypes: [],
            dossier: null,
            selectedFiles: [],
            selectedProviderFiles: []
        };
        this.save = this.save.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.delete = this.delete.bind(this);
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.dossierType = React.createRef();
        this.dossierFiles = React.createRef();
    }

    async componentDidMount() {
        await this.getDossierTypes()
        if (this.props.my_dossier_id != null) {
            await this.getDossier()
        }

        const fv = FormValidation.formValidation(KTUtil.getById('frm'), {
            fields: {
                title: {
                    validators: {
                        notEmpty: {
                            message: 'Nombre requerido'
                        },
                        stringLength: {
                            min: 4,
                            max: 200,
                            message: 'El nombre debe tener una longitud mínima de 4'
                        },
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        });

        const btnPublish = document.getElementById('btnPublish');
        btnPublish.addEventListener('click', () => {
            fv.validate().then((status) => {
                if (status == 'Valid') {
                    if (this.dossierFiles.current.state.selectedFiles.length > 0 || this.dossierFiles.current.state.selectedProviderFiles.length > 0) {
                        this.save();
                    } else {
                        swal.fire({
                            text: "Debes seleccionar al menos un usuario",
                            icon: "info",
                            buttonsStyling: false,
                            confirmButtonText: "Aceptar",
                            customClass: {
                                confirmButton: "btn font-weight-bold btn-primary"
                            }
                        })
                    }
                }
            });
        });
    }

    componentDidUpdate() {
    }

    handleTitleChange(e) {
        this.setState({ title: e.target.value });
    }

    async getDossierTypes() {
        const res = await axios.get('/api/dossiers/types')
        this.setState({dossierTypes: res.data})
    }

    async getDossier() {
        const res = await axios.get('/api/my_dossiers/' + this.props.my_dossier_id)
        this.setState({dossier: res.data, title: res.data.title})
        this.dossierType.current.value = res.data.dossier_type_id
        const selectedProviderFiles = this.state.dossier.providerFiles.map((d) => {
            return {
                id: d.file_id
            }
        })

        this.setState({
            selectedProviderFiles: selectedProviderFiles
        })

        const selectedFiles = this.state.dossier.files.map((d) => {
            return {
                id: d.file_id
            }
        })

        this.setState({
            selectedFiles: selectedFiles
        })
    }

    save() {
        window.blockUI();
        KTUtil.btnWait(KTUtil.getById('btnPublish'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
        const files = this.dossierFiles.current.state.selectedFiles.map(d => d.id)
        const providerFiles = this.dossierFiles.current.state.selectedProviderFiles.map(d => d.id)
        const params = JSON.stringify({
            title: this.state.title,
            dossier_type: this.dossierType.current.value,
            files: files,
            providerFiles: providerFiles,
        })
        if (this.props.my_dossier_id != null) {
            const providerFiles = this.state.selectedProviderFiles.map(d => d.id)
            this.update(params)
        } else {
            this.create(params)
        }
    }

    async create(params) {
        await axios.post(
            '/api/my_dossiers',
            params,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            if (this.state.active) {
                KTUtil.btnRelease(KTUtil.getById('btnPublish'));
            } else {
                KTUtil.btnRelease(KTUtil.getById('btnSave'));
            }
            swal.fire({
                text: "Guardado",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                window.location.href = '/my_dossiers';
            });
        })
        .catch((error) => {
            window.unblockUI();
            const message = getErrorsMessage(error);
            if (this.state.active) {
                KTUtil.btnRelease(KTUtil.getById('btnPublish'));
            } else {
                KTUtil.btnRelease(KTUtil.getById('btnSave'));
            }
            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        });
    }

    async update(params) {
        await axios.put(
            '/api/my_dossiers/' + this.props.my_dossier_id,
            params,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            if (this.state.active) {
                KTUtil.btnRelease(KTUtil.getById('btnPublish'));
            } else {
                KTUtil.btnRelease(KTUtil.getById('btnSave'));
            }
            swal.fire({
                text: "Guardado",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                window.location.href = '/my_dossiers';
            });
        })
        .catch((error) => {
            window.unblockUI();
            const message = getErrorsMessage(error);
            KTUtil.btnRelease(KTUtil.getById('btnPublish'));
            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        });
    }

    confirmDelete() {
        swal.fire({
            text: "¿Desea continuar con el borrado?",
            showCancelButton: true,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            customClass: {
                confirmButton: "btn font-weight-bold btn-primary",
                cancelButton: "btn font-weight-bold btn-danger"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.delete();
            }
        });
    }

    async delete() {
        window.blockUI();
        await axios.delete(
            '/api/my_dossiers/' + this.props.my_dossier_id,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            KTUtil.btnRelease(KTUtil.getById('btnDelete'));
            swal.fire({
                text: getSuccessMessage(response),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                window.location.href = '/my_dossiers';
            });
        }).catch((error) => {
            window.unblockUI();
            const message = getErrorsMessage(error);
            KTUtil.btnRelease(KTUtil.getById('btnDelete'));

            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
        });
    }

    render() {
        const { lang } = this.context; 
        return (
            <form id="frm">
                <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                    <div className="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                        <div className="d-flex align-items-center flex-wrap mr-1">
                            <div className="d-flex align-items-baseline flex-wrap mr-5">
                                <h5 className="text-dark font-weight-bold my-1 mr-5">
                                    {this.state.dossier != null ? this.state.dossier.title : 'Mi Nuevo expediente'}
                                    &nbsp;
                                    <small className="text-muted font-weight-bold">{lang.get('messages.selecciona_los_archivos_para_este_expediente')}</small>
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="d-flex flex-column-fluid">
                    <div className="container">
                        <div className="card card-custom gutter-b">
                            <div className="card-body">
                                <div className="row justify-content-center text-left">
                                    <div className="col-sm-6 form-group">
                                        <label htmlFor="title" className="text-left">{lang.get('messages.nombre')}</label>
                                        <input id="title" type="text" className="form-control form-control-solid" name="title" value={this.state.title} required autoFocus onChange={this.handleTitleChange}/>
                                    </div>
                                    <div className="col-sm-6 form-group">
                                        <label htmlFor="dossier_type " className="text-left">{lang.get('messages.tipo_de_expediente')}</label>
                                        <select ref={this.dossierType} id="dossier_type " name="dossier_type" className="form-control form-control-solid">
                                            {this.state.dossierTypes.map((t, i) => {
                                                return <option key={i} value={t.id}>{t.title}</option>;
                                            })}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <MyDossierFiles ref={this.dossierFiles} selected_files={this.state.selectedFiles.length > 0 ? this.state.selectedFiles : undefined}
                        selected_provider_files={this.state.selectedProviderFiles.length > 0 ? this.state.selectedProviderFiles : undefined}
                        />

                        <div className="row justify-content-end mt-6">
                            <div className="col-sm-6 text-right">
                                { this.props.my_dossier_id != null &&
                                    <button id="btnDelete" type="button" className="btn btn-lg btn-link text-danger ml-4" onClick={this.confirmDelete}>
                                        {lang.get('messages.borrar_expediente')}
                                    </button>
                                }
                                <a href="/my_dossiers" className="btn btn-lg btn-secondary">
                                    {lang.get('messages.cancelar')}
                                </a>
                                <button id="btnPublish" type="button" className="btn btn-lg btn-primary ml-4">
                                    {lang.get('messages.guardar')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default MyDossierForm;

if (document.getElementById('MyDossierForm')) {
    ReactDOM.render(<MyDossierForm />, document.getElementById('MyDossierForm'));
}
